/* eslint-disable */
//SAC por UF (demanda Out/2026): o cadastro pelo SAC (segmento :grupo = 'sac' na URL) só fica disponível para
//estas UFs; nas demais o cidadão vê a MENSAGEM_SAC_INDISPONIVEL no lugar do formulário.
//O servidor recusa o cadastro com a mesma regra (ServiceLayer/SacPorUF.cs).
//Para desfazer: apagar este arquivo e os trechos marcados "SAC por UF" em CadastrarProtocoloForm.js.

var UFS_SAC_DISPONIVEL = ['MG', 'GO', 'PR'];

export var MENSAGEM_SAC_INDISPONIVEL = 'SAC indisponível para sua UF';

//grupo: segmento :grupo da URL; sigla: UF de origem (da URL ou escolhida no select). Sem UF ainda não há o que bloquear.
export function sacIndisponivel(grupo, sigla) {
    if (typeof grupo !== 'string' || grupo.toLowerCase() !== 'sac') return false;
    if (typeof sigla !== 'string' || sigla === '') return false;
    return UFS_SAC_DISPONIVEL.indexOf(sigla.toUpperCase()) === -1;
}

//Sigla da UF pelo id, na lista de UFs do store (envelope { dado: [...] })
export function siglaDaUF(uf, idUF) {
    if (!uf || !uf.dado || !idUF) return '';
    for (var i = 0; i < uf.dado.length; i++) {
        if (uf.dado[i].mIdUF.toString() === idUF.toString()) return uf.dado[i].mSigla;
    }
    return '';
}



/** WEBPACK FOOTER **
 ** ./src/components/util/SacUF.js
 **/